import moment from 'moment';
import distanceCalculator from '../api/distanceCalculator'

const mutations = {
  Initialize(state, bootdata) {
    state.ClientPractices = bootdata.ClientPractices;
    state.Sexes = bootdata.Sex;
    state.Debug  = bootdata.Debug;
    state.NoImage = bootdata.noImage;
    state.ClientPractice = bootdata.ClientPractices[0];
  },
  PracticeSelected(state, selectedPractice) {
    state.SelectedClientPractice = selectedPractice;
  },
  SetPageNumber(state, pageNumber) {
    state.PageNumber = pageNumber;
  },
  UpdateDistances(state, place) {
    state.ClientPractices.forEach(practice => {
      var currentLocationLat = place.geometry.location.lat();
      var currentLocationLang = place.geometry.location.lng();
      var distance = distanceCalculator.calculateDistance(currentLocationLat, currentLocationLang,
        practice.Lat, practice.Lng);
      practice.Mile = distance;
    });
  },
  ResetPracticeAvailableSlots(state) {
    state.SlotPageNumber = 0;
    state.AppointmentSlots = [];
  },
  IncrementSlotPageNumber(state) {
    state.SlotPageNumber += 1;
  },
  SetPracticeAvailableSlots(state, slots) {
    state.AppointmentSlots.push(...slots);
  },
  SetAppointmentType(state, isSickAppointment){
    state.IsSickAppointment = isSickAppointment;
  },
  SetAppointmentDay(state, appointmentDay) {
    state.SelectedAppointmentDay = appointmentDay;
  },
  SetAppointmentDateTime(state, appointmentDateTime) {
    state.SelectedAppointmentDateTime = appointmentDateTime;
  },
  ShowLoading(state, value) {
    state.IsLoading = value;
  },
  ShowCalendarLoading(state, value) {
    state.IsCalendarLoading = value;
  },
  InitializeState(state, value) {
    state.States = value;
  },
  InitializeDueVaccine(state, vaccines) {
    state.DueServices = vaccines;
  },
  InitializeSpecies(state, species) {
    state.Species = species;
  },
  UpdateFirstName(state, firstName) {
    state.PetOwnerDetails.FirstName = firstName
  },
  UpdateLastName(state, lastName) {
    state.PetOwnerDetails.LastName = lastName
  },
  UpdateEmailAddress(state, email) {
    state.PetOwnerDetails.EmailAddress = email
  },
  UpdatePhone(state, phone) {
    state.PetOwnerDetails.Phone = phone
  },
  UpdateAddress(state, address) {
    state.PetOwnerDetails.Address = address
  },
  UpdateCity(state, city) {
    state.PetOwnerDetails.City = city
  },
  UpdateState(state, stateName) {
    state.PetOwnerDetails.State = stateName
  },
  UpdateZip(state, zip) {
    state.PetOwnerDetails.Zip = zip
  },
  UpdateVisitComments(state, comment) {
    state.VisitComments = comment
  },
  SetRequestedServices(state, services) {
    state.RequestedServices = services
  },
  InitializePets(state, pets) {
    state.Pets = pets;
  },
  InitializePetOwner(state, pet) {
    state.PetOwnerId = pet.PetOwnerId;
    state.PetOwnerId_Ext = pet.PetOwnerId_Ext;
  },
  UpdateSpecies(state, species) {
    state.NewPetForm.Species = species;
    if (species == "-- Select --") {
      state.NewPetForm.Breed = "-- Select --";
    }
  },
  UpdateBreed(state, breed) {
    state.NewPetForm.Breed = breed;
  },
  UpdatePetName(state, name) {
    state.NewPetForm.Name = name;
  },
  UpdateSex(state, sex) {
    state.NewPetForm.Sex = sex;
  },
  UpdateColor(state, color) {
    state.NewPetForm.Color = color;
  },
  UpdateDateOfBirth(state, dateOfBirth) {
    dateOfBirth = dateOfBirth.replace("_","");
    state.NewPetForm.DateOfBirth = dateOfBirth;
    if (dateOfBirth && moment(dateOfBirth).isValid) {
      state.NewPetForm.FormattedDateOfBirth = moment(dateOfBirth).format("MM/DD/YYYY");
    } else {
      state.NewPetForm.FormattedDateOfBirth = null;
    }
  },
  SetSelectedPet(state, pet) {
    state.SelectedPet = pet;
  },
  ResetSelectedPet(state){
    state.SelectedPet = null;
    state.DueServices = [];
  },
  ResetStore(state) {
    state.SelectedPet = null;
    state.PetOwnerId = null;
    state.AppointmentSlots = [];
    state.SelectedAppointmentDay = {};
    state.VisitComments = '';
    state.RequestedServices = [];
    state.DueServices = [];
    state.NewPetForm.Name = '';
    state.NewPetForm.Species = '-- Select --';
    state.NewPetForm.Breed = '-- Select --';
    state.NewPetForm.Color = '';
    state.NewPetForm.Sex = '-- Select --';
    state.NewPetForm.DateOfBirth = null;
    state.NewPetForm.FormattedDateOfBirth = null;
    state.PetOwnerDetails = {
      FirstName: '',
      LastName: '',
      Phone: '',
      EmailAddress: '',
      Address: '',
      City: '',
      State: '-- Select --',
      Zip: ''
    }
  },
  ResetDate(state){
    state.SelectedAppointmentDateTime ={};
  },
  ResetServices(state){
    state.RequestedServices = [];
    state.DueServices = [];
    state.VisitComments = '';
  }
}

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js